import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5cad05c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pin-angle-fill fs-3" })
], -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  class: "d-none d-lg-flex flex-column align-items-center flex-column-auto py-1 aside-logo",
  id: "kt_aside_logo"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "aside-menu flex-column-fluid" }
const _hoisted_9 = {
  class: "aside-footer flex-column-auto pt-5 pb-7 px-5",
  id: "kt_aside_footer"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<span class=\"btn-label\" data-v-5cad05c7>Aplicativo Web</span><span class=\"svg-icon btn-icon svg-icon-2 svg-icon-white\" data-v-5cad05c7><svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" data-v-5cad05c7><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" data-v-5cad05c7><rect x=\"0\" y=\"0\" width=\"24\" height=\"24\" data-v-5cad05c7></rect><path d=\"M6.5,4 L6.5,20 L17.5,20 L17.5,4 L6.5,4 Z M7,2 L17,2 C18.1045695,2 19,2.8954305 19,4 L19,20 C19,21.1045695 18.1045695,22 17,22 L7,22 C5.8954305,22 5,21.1045695 5,20 L5,4 C5,2.8954305 5.8954305,2 7,2 Z\" fill=\"#000000\" fill-rule=\"nonzero\" data-v-5cad05c7></path><polygon fill=\"#000000\" opacity=\"0.3\" points=\"6.5 4 6.5 20 17.5 20 17.5 4\" data-v-5cad05c7></polygon></g></svg></span>", 2)
const _hoisted_12 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTMenu = _resolveComponent("KTMenu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "kt_aside",
    class: _normalizeClass(["aside aside-hoverable fundo-rodape", [
      _ctx.asideTheme === 'light' && 'aside-light',
      _ctx.asideTheme === 'dark' && 'aside-dark',
    ]]),
    "data-kt-drawer": "true",
    "data-kt-drawer-name": "aside",
    "data-kt-drawer-activate": "{default: true, lg: false}",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
    "data-kt-drawer-direction": "start",
    "data-kt-drawer-toggle": "#kt_aside_mobile_toggle",
    onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleMouseEvent(true))),
    onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleMouseEvent(false)))
  }, [
    _createElementVNode("div", {
      id: "kt_aside_toggle",
      class: _normalizeClass(["btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle align-logo-aside", { show : _ctx.showIcon }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleShowIcon && _ctx.handleShowIcon(...args))),
      "data-kt-toggle": "true",
      "data-kt-toggle-state": "active",
      "data-kt-toggle-target": "body",
      "data-kt-toggle-name": "aside-minimize"
    }, _hoisted_2, 2),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.asideTheme === 'dark')
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.rota())),
            href: "#"
          }, [
            _withDirectives(_createElementVNode("img", {
              alt: "Logo",
              src: _ctx.logoShow
            }, null, 8, _hoisted_4), [
              [_vShow, _ctx.showIcon]
            ]),
            _withDirectives(_createElementVNode("img", {
              alt: "Logo",
              src: _ctx.darkLogo
            }, null, 8, _hoisted_5), [
              [_vShow, !_ctx.showIcon]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.asideTheme === 'light')
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.rota())),
            href: "#"
          }, [
            _withDirectives(_createElementVNode("img", {
              alt: "Logo",
              src: _ctx.logoShow
            }, null, 8, _hoisted_6), [
              [_vShow, _ctx.showIcon]
            ]),
            _withDirectives(_createElementVNode("img", {
              alt: "Logo",
              src: _ctx.darkLogo
            }, null, 8, _hoisted_7), [
              [_vShow, !_ctx.showIcon]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_KTMenu)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("a", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.redirect && _ctx.redirect(...args))),
        target: "_blank",
        class: "btn btn-custom background_btn_1 w-100",
        "data-bs-toggle": "tooltip",
        "data-bs-trigger": "hover",
        "data-bs-dismiss-": "click",
        title: "",
        "data-bs-original-title": "200+ in-house components and 3rd-party plugins",
        "data-original-title": ""
      }, _hoisted_12)
    ])
  ], 34))
}